<template>
  <div class="content">
    <navigation :navName="nav"></navigation>
    <template>
      <el-form ref="editForm"
               :model="editForm"
               class="mobile-show-box form-wrapper"
               :label-width="formLabelWidth"
               :rules='formRule'>
        <el-form-item label="发布栏目"
                      prop='column'>
          <el-checkbox-group v-model="editForm.column">
            <el-checkbox :label="item.name"
                         v-for="(item,index) in columns"
                         :key="index"
                         @change="getColumn(item)">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop='title'
                      label="标题">
          <el-input placeholder="请输入标题"
                    v-model="editForm.title"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="mobile_img"
                      label="缩略图">
          <div class="single-img-upload">
            <el-upload :action="imgUpload"
                       :headers="isOverSea"
                       :class="{disabled:uploadDisabled}"
                       list-type="picture-card"
                       :on-preview="handlePictureCardPreview"
                       :on-success="handlePictureSuccess"
                       :on-remove="handleRemove"
                       :before-upload="beforeAvatarUpload"
                       :file-list="imgList">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%"
                   :src="dialogImageUrl"
                   alt="">
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="摘要">
          <el-radio v-model="editForm.isAbstract"
                    label="true">手动编辑</el-radio>
          <el-radio v-model="editForm.isAbstract"
                    label="false">自动截取正文前100字作为摘要</el-radio>
        </el-form-item>
        <el-form-item label=""
                      v-if="editForm.isAbstract=='true'">
          <el-input type="textarea"
                    size="mini"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="editForm.abstract">
          </el-input>
        </el-form-item>
        <el-form-item label="正文"
                      prop="text">
          <wang-editor @getEditor="getEditorContent">
          </wang-editor>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-radio v-model="editForm.isSetTop"
                    label="1">置顶</el-radio>
          <el-radio v-model="editForm.isSetTop"
                    label="0">不置顶</el-radio>
        </el-form-item>
        <el-form-item label="是否发布">
          <el-radio v-model="editForm.release"
                    label="true">发布</el-radio>
          <el-radio v-model="editForm.release"
                    label="false">不发布</el-radio>
        </el-form-item>
        <el-form-item label="推荐首页"
                      prop="official_pkg_url">
          <el-checkbox-group v-model="editForm.isSetHome"
                             @change="getSetHome">
            <el-checkbox :label="item.name"
                         v-for="(item,index) in columns"
                         :key="index">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="文章时间">
          <el-date-picker v-model="editForm.editTime"
                          type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          size="mini">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="优先级排序">
          <el-input type="number"
                    min="0"
                    size="mini"
                    v-model="editForm.sort"
                    class="num-input">
          </el-input>
          <span class="warning-span">注：数字越小优先级越高</span>
        </el-form-item>
        <el-form-item label="文章来源">
          <el-input placeholder="请输入内容"
                    v-model="editForm.source"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="页面标题">
          <el-input placeholder="请输入内容"
                    v-model="editForm.titleHead"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input placeholder="请输入内容"
                    v-model="editForm.keywords"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    size="mini"
                    v-model="editForm.describe">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini"
                     type="primary"
                     @click="addArt()">提交</el-button>
          <el-button size="mini"
                     @click="back()">取消</el-button>
        </el-form-item>
      </el-form>
    </template>
  </div>
</template>
<style lang="less" scoped>
.disabled {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
</style>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import wangEditor from '../wangEditor/wangEditor';
import navigation from './navigation';
import api from '../../api/api';


export default {
  data() {
    return {
      id: '',
      dialogImageUrl: '',
      dialogVisible: false,
      editForm: {
        column: [],
        title: '',
        titleHead: '',
        img: '',
        isAbstract: 'true',
        isSetTop: '1',
        abstract: '',
        content: '123',
        isSetHome: [],
        source: '',
        keywords: '',
        describe: '',
        release: 'false',
        editTime: new Date(),
        sort: 0,
      },
      formLabelWidth: '90px',
      formRule: {
        column: [{ required: true, message: '请选择发布栏目', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        text: [{ required: true, message: '请输入正文内容', trigger: 'blur' }],
      },
      imgUpload: `${api.url}upload`,
      uploadDisabled: false,

      imgList: [],

      nav: '',


    };
  },
  created() {
    this.editForm.column.push(this.$store.state.navName);
    if (this.$store.state.articleId) {
      this.id = this.$store.state.articleId;
      axios.post(`${api.url}articleDetail`, { id: this.$store.state.articleId }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          const content = data.content;
          this.editForm = content;
          if (content.img) {
            this.uploadDisabled = true;
            this.editForm.img = content.img;
            this.imgList = [{ url: this.$store.state.publicUrl + content.img, status: 'finished' }];
          }
          this.editForm.isAbstract = `${content.isAbstract}`;
          this.editForm.release = `${content.release}`;
          this.editForm.isSetTop = `${content.isSetTop}`;
          this.$store.commit('getEditorContent', content.text);
          this.editForm.editTime = new Date(content.editTime);
        }
      });
    }
  },
  computed: {
    ...mapState([
      'activityLeft',
      'columns',
    ]),
    isOverSea() {
      const object = {};
      object.isOverSea = this.$store.state.is_overSea;
      return object;
    },
  },
  components: {
    wangEditor,
    navigation,
  },
  methods: {
    getEditorContent(editor) {
      this.editor = editor;
    },
    back() {
      this.$router.back(-1);
    },
    addArt() {
      this.editForm.content = this.editor.txt.html();
      if (this.editForm.title === '') {
        this.$message({
          message: '请填写标题',
          type: 'warning',
        });
        return;
      }
      if (this.editor.txt.text() === '' && (this.editor.txt.html().indexOf('img') < 0 && this.editor.txt.html().indexOf('iframe') < 0)) {
        this.$message({
          message: '请填写正文内容',
          type: 'warning',
        });
        return;
      }
      if (this.editForm.column.length === 0) {
        this.$message({
          message: '请至少选择一个栏目',
          type: 'warning',
        });
        return;
      }
      if (this.editForm.isAbstract === 'false') {
        this.abstract = this.editor.txt.text().substring(0, 100);
      }
      const data = Object.assign(this.editForm, {
        wid: this.$store.state.websiteId,
        id: this.id,
        text: this.editForm.content,
      });
      axios.post(`${api.url}addArticle`, data).then((response) => {
        if (response.data.ret === 0) {
          this.$alert(response.data.msg, '', {
            confirmButtonText: '确定',
            callback: () => {
              const artData = {
                type: this.$store.state.navName,
                wid: this.$store.state.websiteId,
                pageSize: 20,
                pageNum: 1,
              };
              this.$store.dispatch('getArticle', artData);
              window.history.back();
            },
          });
        } else {
          this.$alert('服务器出错', '', {
            confirmButtonText: '确定',
            callback: () => {
            },
          });
        }
      });
    },
    handleRemove() {
      this.uploadDisabled = false;
      this.editForm.img = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureSuccess(file) {
      if (file.ret === 0) {
        this.uploadDisabled = true;
        this.editForm.img = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isGif = file.type === 'image/gif';
      if (!isJPG && !isPng && !isGif) {
        this.$message.error('上传图片只能是 JPG 格式,GIF格式 或者 PNG 格式!');
      }
    },
    getSetHome(arr) {
      const that = this;
      arr.forEach((item, index) => {
        if (!that.editForm.column.includes(item)) {
          that.$message({
            message: '必须与上方发布的栏目对应',
            type: 'warning',
          });
          that.editForm.isSetHome.splice(index, 1);
        }
      });
    },
    getColumn(item) {
      const name = item.name;
      const arr = this.editForm.isSetHome;
      const _ = this;
      arr.forEach((column) => {
        if (column === name) {
          _.editForm.isSetHome.splice(arr.indexOf(item), 1);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/websiteConfig/addArticle.vue